<template>
  <b-modal id="cookies-warning" size="xl" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc :visible="showMsg">
    <div class="box-wrapper">
      <div class="text-wrapper">
        <h6 class="text-white mt-1 mb-2">THIS WEBSITE USES COOKIES</h6>
        <p class="xxsmall">We use cookies for two reasons. First, we use cookies that are strictly necessary
          for the operation and security of the website and second, we use cookies to identify you and
          analyze our traffic provided that you have given your permission by checking the box
          “Statistics”.</p>
      </div>

      <div class="checkboxes mb-5">
        <div class="checkbox-wrapper disabled" @click="alert(alertMsg)">
          <label for="necessary">
            <span class="checkbox-text">NECESSARY</span>
            <input id="necessary" v-model="cookies.necessary" type="checkbox" disabled />
            <span class="checkbox"></span>
          </label>
        </div>
        <div class="checkbox-wrapper">
          <label for="statistics">
            <span class="checkbox-text">STATISTICS</span>
            <input id="statistics" v-model="cookies.statistics" type="checkbox" />
            <span class="checkbox"></span>
          </label>
        </div>
        <div class="checkbox-wrapper">
          <label for="advertising">
            <span class="checkbox-text">ADVERTISING</span>
            <input id="advertising" v-model="cookies.advertising" type="checkbox" />
            <span class="checkbox"></span>
          </label>
        </div>
      </div>

      <div class="d-flex flex-column align-items-center">
        <button type="button" class="btn-accept-all mb-3" @click="acceptAll()">ACCEPT ALL</button>

        <button type="button" class="btn-accept-selected" @click="acceptSelected()">ACCEPT ONLY SELECTED COOKIES</button>

        <button type="button" @click="toggleDetails()" class="btn-details" :class="{'active': details}">
          <span>MORE DETAILS</span>
        </button>
      </div>

      <transition name="height">
        <div class="details" v-if="details">
          <div class="tabs">
            <div class="tabs-btns">
              <button type="button" class="tab-btn" :class="{'active': tab===1}" @click="tab=1">
                <slot name="tab-1">COOKIE DECLARATION</slot>
              </button>
              <button type="button" class="tab-btn" :class="{'active': tab===2}" @click="tab=2">
                <slot name="tab-2">ABOUT COOKIES</slot>
              </button>
            </div>

            <div class="tab-content">
              <div v-if="tab===1" class="tabs-hor">
                <div class="tabs-hor-btns">
                  <button type="button" class="tab-btn-hor" :class="{'active': tabHor===1}" @click="tabHor=1">NECESSARY</button>
                  <button type="button" class="tab-btn-hor" :class="{'active': tabHor===2}" @click="tabHor=2">STATISTICS</button>
                  <button type="button" class="tab-btn-hor" :class="{'active': tabHor===3}" @click="tabHor=3">ADVERTISING</button>
                </div>

                <div class="tab-content-hor">
                  <div v-if="tabHor===1" v-bar="{preventParentScroll: true}" class="h-100">
                    <div>
                      <p class="xxsmall text-left font-weight-book mb-3">
                        <span class="text-underline-simple">Necessary cookies</span> are used to provide
                        and protect our services while providing a swift and safer browsing experience
                        by enabling basic functions like page navigation. The website cannot function
                        properly without these cookies.
                      </p>
                      <table id="tb-necessary" class="table-md-responsive table-cookies">
                        <thead>
                          <tr>
                            <th>COOKIE NAME</th>
                            <th>PURPOSE</th>
                            <th>TYPE</th>
                            <th>STORAGE</th>
                            <th>EXPIRATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>showCookiesMsg</td>
                            <td>Used to your cookie consent state for our domain.</td>
                            <td>Technical</td>
                            <td>Optional</td>
                            <td>1 month</td>
                          </tr>

                          <tr>
                            <td>laravel_session</td>
                            <td>
                              Used to create a session ID for the user, so that the system itself
                              can identify you as a unique and individual user, distinct from
                              anyone else looking at the website.
                            </td>
                            <td>Session</td>
                            <td>Necessary</td>
                            <td>Session</td>
                          </tr>

                          <tr>
                            <td>XSRF-TOKEN</td>
                            <td>
                              Used to enhance security of our Services and prevent repeated
                              attempts as intrusions of our Services
                            </td>
                            <td>Technical</td>
                            <td>Necessary</td>
                            <td>Session</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="tabHor===2" v-bar="{preventParentScroll: true}" class="h-100">
                    <div>
                      <p class="xxsmall text-left font-weight-book mb-3">
                        <span class="text-underline-simple">Statistics cookies</span> help website owners
                        to understand how visitors interact with websites by collecting and reporting
                        information anonymously.
                      </p>
                      <table id="tb-statistics" class="table-md-responsive table-cookies">
                        <thead>
                          <tr>
                            <th>COOKIE NAME</th>
                            <th>PURPOSE</th>
                            <th>TYPE</th>
                            <th>STORAGE</th>
                            <th>EXPIRATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>_ga</td>
                            <td>
                              Registers a unique ID that is used to generate statistical data on
                              how the visitor uses the website.
                            </td>
                            <td>Third-party (Google Tag Manager Google)</td>
                            <td>Optional</td>
                            <td>2 years</td>
                          </tr>

                          <tr>
                            <td>_gid</td>
                            <td>
                              Registers a unique ID that is used to generate statistical data on
                              how the visitor uses the website.
                            </td>
                            <td>Third-party (Google Tag Manager Google)</td>
                            <td>Optional</td>
                            <td>24 hours</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="tabHor===3" v-bar="{preventParentScroll: true}" class="h-100">
                    <div>
                      <p class="xxsmall text-left font-weight-book mb-3">
                        <span class="text-underline-simple">Advertising cookies</span> help website
                        owners to understand how visitors interact with websites by collecting and
                        reporting information anonymously.
                      </p>
                      <table id="tb-statistics" class="table-md-responsive table-cookies">
                        <thead>
                          <tr>
                            <th>COOKIE NAME</th>
                            <th>PURPOSE</th>
                            <th>TYPE</th>
                            <th>STORAGE</th>
                            <th>EXPIRATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>_gcl_au</td>
                            <td>
                              Used by Google AdSense for experimenting with advertisement efficiency across websites using their services<br>The main purpose of this cookie is: Targeting/Advertising
                            </td>
                            <td>Third-party (Google Tag Manager Google)</td>
                            <td>Optional</td>
                            <td>3 months</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="h-100">
                <div v-if="tab==2" v-bar="{preventParentScroll: true}" class="h-100">
                  <div class="text-left py-2 px-4 xxsmall">
                    <p>
                      We use cookies in this website, small text files with information on your
                      navigation in this site, whose principal objective is to improve your experience
                      in the website. In this webpage you shall find all the relevant information
                      regarding the use of cookies in our website. We strongly recommend you to read
                      through the following text from time to time as we might proceed with amendments
                      in the future. For any question or clarification feel free to use our contact
                      information or the contact form.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </b-modal>
</template>

<script>
  import Vue from "vue";

  import Vuebar from "vuebar";
  Vue.use(Vuebar);

  import {
    BModal
  } from 'bootstrap-vue';
  // Vue.component('b-modal', BModal)

  import VueCookies from "vue-cookies";
  Vue.use(VueCookies);

  import vueResource from "vue-resource";
  Vue.use(vueResource);

  Vue.http.headers.common["X-CSRF-TOKEN"] = window.Laravel.csrfToken;

  export default {
    components: {
      BModal
    },
    props: {
      alertMsg: {
        type: String,
        required: false,
        default: "Υποχρεωτικά cookies. Τα απαραίτητα cookies επιτρέπουν την εκτέλεση βασικών λειτουργιών του site."
      }
    },
    data() {
      return {
        showMsg: false,
        details: false,
        tab: 1,
        tabHor: 1,
        cookies: {
          necessary: true,
          statistics: false,
          advertising: false
        }
      };
    },
    methods: {
      getMsgCookie() {
        return (
          this.$cookies.get("showCookiesMsg") == "true" ||
          this.$cookies.get("showCookiesMsg") == null
        );
      },
      setMsgCookie(value, time) {
        this.$cookies.set("showCookiesMsg", value, time);
        this.showMsg = value;
      },
      acceptAll() {
        const component = this;

        component.cookies.necessary = true;
        component.cookies.statistics = true;
        component.cookies.advertising = true;

        component.$http
          .post("/en/setcookies/pref", component.cookies)
          .then(
            function (success) {
              component.setMsgCookie(false, "1d");
            },
            function (error) {
              console.log(error);
            }
          );

        setTimeout(function () {
          component.setMsgCookie(false, "7d");
        }, 1000);
      },
      acceptSelected() {
        const component = this;

        component.$http
          .post("/en/setcookies/pref", component.cookies)
          .then(
            function (success) {
              component.setMsgCookie(false, "1d");
            },
            function (error) {
              console.log(error);
            }
          );

        setTimeout(function () {
          component.setMsgCookie(false, '1d');
        }, 1000);
      },
      toggleDetails() {
        this.details = !this.details;
      },
      alert(message) {
        window.alert(message);
      },
    },
    mounted() {
      this.showMsg = this.getMsgCookie();
    }
  };
</script>